function IconYoutube() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={512} height={512} viewBox="0 0 176 176">
      <g data-name="Layer 2">
        <g data-name="02.youtube">
          <path
            fill="#e60000"
            d="M144.52 173a532.59 532.59 0 01-113 0A32.07 32.07 0 013 144.52a532.59 532.59 0 010-113A32.07 32.07 0 0131.48 3a532.59 532.59 0 01113 0A32.07 32.07 0 01173 31.48a532.59 532.59 0 010 113A32.07 32.07 0 01144.52 173z"
            data-original="#e60000"
          />
          <path
            fill="#fff"
            d="M140.43 61.54c-2.2-6.77-9.48-10.87-16.18-11.81a343.16 343.16 0 00-72.5 0c-6.7.94-14 5-16.18 11.81a137.42 137.42 0 000 52.93c2.2 6.76 9.48 10.87 16.18 11.81a343.16 343.16 0 0072.5 0c6.7-.94 14-5 16.18-11.81a137.42 137.42 0 000-52.93zm-65.59 47.54V66.92L109.16 88c-11.57 7.11-22.8 14-34.32 21.08z"
            data-original="#ffffff"
          />
        </g>
      </g>
    </svg>
  );
}

export default IconYoutube;
